import { InvoiceException } from '@/domain/stripe/invoice/repository/contract/exception/InvoiceException'

export class CouldNotGetCustomerInvoicesException extends InvoiceException {

}